import React from 'react';
import {
  Player,
  PlayerPair,
  EmptyPlayer,
  EmptyPlayerSlot,
  PlayersCount,
  PlayersCountNoNum,
  PlayersInner,
  PlayersList,
  PlayersPairs,
  NoPlayersMessage,
  ActionButton,
  LoginButton,
  NoActionButton,
  GamePlayers,
  KingOfTheHillPlayers,
  KingOfTheHillResults,
  KingOfTheHillPrePlayers,
  MorningOpenPlayers,
  MorningOpenPrePlayers,
  RandomRelationsPlayers,
  RandomRelationsResults,
  RandomRelationsPrePlayers,
  RandomRelationsMiniPlayers,
  TrainingQueue,
  GameDetailsInnerSummary,
  AlertInfo,
  AlertDanger,
  AlertPrepayment,
  AlertAfterReg,
  AlertTraining
} from './final.js';

class PlayerInner extends React.Component {

  constructor(props) {
    super(props);
  }

  levelLabel = () => {
           if((this.props.player._place != 2 && this.props.player._place != 3) && (this.props.player._place_level != ""))
               return(
                    <div className="place-info">
                    <b> {this.props.player._place_level} </b>
                    </div>
               )
  }

  playerWithEmoji = () => {
    const { gameType, player, flag } = this.props;
    // console.log('PlayerInner props:', this.props);
    
    if (flag === " +1") {
        const friendGender = player._friend_sex === 'M' ? '🕺' : '💃';
        
        return (
            <div className="game__list-user-name">
                <a href={'/profile/'+ player._id + '/'}>
                    {player._first_name + ' ' + player._last_name
                                + ' + ' + friendGender
                                + ' ' + player._friend_payment_emoji}
                </a>
            </div>
        );
    } else {
        return (
            <div className="game__list-user-name">
                <a href={'/profile/'+ player._id + '/'}>
                    {player._first_name + ' ' + player._last_name 
                                + ' ' + player._emoji}
                </a>
            </div>
        );
    }
  }

  render() {
    const { player, flag, inPairGroup } = this.props;
    const RowTag = inPairGroup ? 'div' : 'li';

    return(
        <React.Fragment>
            {!inPairGroup && this.levelLabel()}
            <RowTag className="game__list-user">
                <div className="game__list-user-photo">
                    {player._rating_level > 0 && (
                        <div className={`player-avatar-ring level-${player._rating_level}`}></div>
                    )}
                    <img className="img-responsive"
                         src={player._photo}
                         alt={player._first_name + ' ' + player._last_name}
                    />
                </div>
                {this.playerWithEmoji()}
            </RowTag>
        </React.Fragment>
    );
  }
}

export default PlayerInner;
